module.exports = __webpack_public_path__ + "static/img-hp-bvf-animated-ef6b0575f5e92a413da263faa0dd72d1.gif";